// extracted by mini-css-extract-plugin
export default {"desktopRoot":"clientDesktop_desktopRoot__NCBuq","desktopMainInner":"clientDesktop_desktopMainInner__VYWLN","desktopWide":"clientDesktop_desktopWide__wvJho"};